import { InjectionToken } from '@angular/core'

export const DEBOUNCE_CONFIG = new InjectionToken<number>('debounceConfig')
